import autel from "./autel.png";
import autelLogo from "./autelLogo.png";
import dji from "./dji.png";
import djiLogo from "./djiLogo.png";
import goPro from "./goPro.png";
import goProLogo from "./goProLogo.png";
import parrot from "./parrot.png";
import parrotLogo from "./parrotLogo.png";
import powerVision from "./powerVision.png";
import powerVisionLogo from "./poweVisionLogo.png";
import ubsan from "./ubsan.png";
import ubsanLogo from "./ubsanLogo.png";
import yuntec from "./yuntec.png";
import yuntecLogo from "./yuntecLogo.png";
import decoration from "./decoration.svg";

export default {
  autel,
  autelLogo,
  dji,
  djiLogo,
  goPro,
  goProLogo,
  parrot,
  parrotLogo,
  powerVision,
  powerVisionLogo,
  ubsan,
  ubsanLogo,
  yuntec,
  yuntecLogo,
  decoration,
};
